import { MarketingService } from './marketing.service';

export default angular
  .module('sfMobile.services.marketing', ['sfMobile.services.localization'])
  .service('marketingService', MarketingService).name;
